import { createRouter, createWebHistory } from 'vue-router';

import EventView from './event/EventView.vue';
import AboutView from './about/AboutView.vue';
import MainView from './main/MainView.vue';
import GalleryView from './gallery/GalleryView.vue';
import EventGalleryView from './gallery/EventGalleryView.vue';
import PreviousEventsView from './event/PreviousEventsView.vue';
import NextEventsView from './event/NextEventsView.vue';

const routes = [
  {
    path: '/',
    name: 'main',
    component: MainView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/event/:id',
    name: 'event',
    component: EventView
  },
  {
    path: '/previousEvents',
    name: 'previousEvents',
    component: PreviousEventsView
  },
  {
    path: '/nextEvents',
    name: 'nextEvents',
    component: NextEventsView
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: GalleryView
  },
  {
    path: '/gallery/:id',
    name: 'eventGallery',
    component: EventGalleryView
  }
];

export const router = createRouter({
  history: createWebHistory(),
  routes
});
